import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Cidade } from '../interfaces/cidade';
import { catchError, tap, filter } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CidadeService {

  readonly path = '/cidade';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  getCidade(code: number ): Observable<Cidade> {
    return this.http.get<Cidade>(`${this.jwtAuthService.apiUrl + this.path}/${code}`);
  }

  getCidadePage(page?: number, size?: number): Observable<PageResult<Cidade>> {
    return this.http.get<PageResult<Cidade>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getCidadeIbge(code: string ): Observable<Cidade> {
    return this.http.get<Cidade>(`${this.jwtAuthService.apiUrl + this.path}/ibge/${code}`);
  }

  getCidadePageSearch(page?: number, size?: number, search?: string): Observable<PageResult<Cidade>> {
    return this.http.get<PageResult<Cidade>>(`${this.jwtAuthService.apiUrl + this.path}/page/get?page=${page}&size=${size}&search=${search}`);
  }

  consultarConvenioNfseNacionalPorIbge(codigoIbge: number | string): Observable<any> {
    return this.http.get<any>(`${this.jwtAuthService.apiUrl + this.path}/nfse/convenio/${codigoIbge}`);
  }

  getItemCidadePageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<Cidade>> {
    return this.http.get<PageResult<Cidade>>(`${this.jwtAuthService.apiUrl + this.path}/page/get?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  saveOrUpdate(cadastro: Cidade): Observable<Cidade> {
    return this.http.put<Cidade>(`${this.jwtAuthService.apiUrl + this.path}`, cadastro);
  }
}

